import React, { useState, useEffect } from 'react';
import axiosInstance from "../../../../axiosInstance";
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import GenericCard from '../../../common/GenericCard';
import Modal from 'apollo-react/components/Modal';
import TextField from 'apollo-react/components/TextField';

// Updated NewRequests Component

const NewRequests = () => {
    const [t] = useTranslation();
    const [data, setData] = useState([]);
    const navigate = useNavigate();
    const [showRequestNameModal, setShowRequestNameModal] = useState(false);
    const [selectedRequestId, setSelectedRequestId] = useState(null);
    const [customRequestName, setCustomRequestName] = useState("");
    const [requestNameError, setRequestNameError] = useState("");

    useEffect(() => {
        const fetchNewRequests = async () => {
            const response = await axiosInstance.get('/api/requests-progress/user/requests/new')
                .catch(err => {
                    console.log(err);
                });
            setData(response?.data);
        };
        fetchNewRequests();
    }, []);

    const handleApply = (id) => {
        setSelectedRequestId(id);
        setShowRequestNameModal(true);
        setCustomRequestName("");
        setRequestNameError("");
    };

    const handleConfirmRequestName = () => {
        const trimmed = customRequestName.trim();
        if (!trimmed) {
            setRequestNameError('Request name is required');
            return;
        }
        
        setShowRequestNameModal(false);
        navigate(`/customer/requests/new-requests/view/${selectedRequestId}?request_name=${encodeURIComponent(trimmed)}`);
    };

    const handleCancelRequestName = () => {
        setShowRequestNameModal(false);
        setSelectedRequestId(null);
        setCustomRequestName("");
        setRequestNameError("");
    };

    return (
        <>
            <div
					style={{
						display: "flex",
                        flexWrap: 'wrap',
						gap: 32,
						marginTop: 40,
					}}
				>
					{" "}
                    {data?.map((item) => (
						<GenericCard
                            key={item.id}
							label={item.name}
							description={
								item.description && item.description.length > 150
									? item.description.substring(0, 150) + "..."
									: item.description
							}
							buttonLabel={t("Apply")}
							onButtonClick={() => handleApply(item.id)}
							imageId={item?.workflow_image_id}
						/>
					))}
				</div>
                <Modal
                    open={showRequestNameModal}
                    onClose={handleCancelRequestName}
                    title={t('Request Name')}
                    size="small"
                    buttonProps={[
                        {
                            label: t('Cancel'),
                            onClick: handleCancelRequestName
                        },
                        {
                            label: t('Confirm'),
                            onClick: handleConfirmRequestName,
                            variant: 'primary'
                        }
                    ]}
                >
                    <TextField
                        label={t('Please enter a request name')}
                        placeholder={t('Ex: Request type - Product name')}
                        value={customRequestName}
                        onChange={(e) => {
                            setCustomRequestName(e.target.value);
                            setRequestNameError("");
                        }}
                        error={Boolean(requestNameError)}
                        helperText={requestNameError}
                        fullWidth
                        style={{ width: '400px' }}
                    />
                </Modal>
        </>
    );
};

export default NewRequests;